<template>
  <div id="container">
    <van-divider content-position="left">订单</van-divider>
    <van-cell-group>
      <van-cell title="订单号" :value='model.code'/>
      <van-cell title="创建时间" :value='model.create_time'/>
      <van-cell title="创建人" :value='model.ent_employee_name'/>
      <van-cell v-if="model.datas!==undefined" title="价格" :value="model.datas.price + '元'"/>
      <van-cell title="节点" :value='model.wor_node_name'/>
    </van-cell-group>

    <van-divider content-position="left">明细</van-divider>
    <div class="card margin-tb-10" v-for="salProduct in salProducts" :key="salProduct.id">
      <van-row>
        <van-col span="4">
          <van-image
            round
            width="100%"
            :src="salProduct.thumb.url"
          />
        </van-col>
        <van-col offset="2" span="18">
          <h4>{{salProduct.name}}</h4>
          <h5>¥{{salProduct.price}}元 * {{salProduct.quantity}}件</h5>
        </van-col>
      </van-row>
    </div>

    <div v-if="model.datas!==undefined&&model.is_check===0">
      <van-cell-group>
        <van-cell center title="是否开发票">
          <template #right-icon>
            <van-switch v-model="model.datas.is_invoice" active-value="1" inactive-value="0"/>
          </template>
        </van-cell>
      </van-cell-group>

      <div v-if="model.datas.is_invoice==1">
        <van-cell-group>
          <van-field v-model="model.datas.invoice_name" label="抬头" placeholder="请输入抬头" />
        </van-cell-group>

        <van-button block type="default" @click="save()">保存发票信息</van-button>
      </div>

      <van-cell-group>
        <van-cell center title="是否配送">
          <template #right-icon>
            <van-switch v-model="model.datas.express_method" active-value="配送" inactive-value="自提"/>
          </template>
        </van-cell>
      </van-cell-group>

      <div v-if="model.datas.express_method==='配送'">
        <van-cell-group>
          <van-field v-model="model.datas.express_name" label="收货人" placeholder="请输入收货人" />
          <van-field v-model="model.datas.express_mobile" label="收货电话" placeholder="请输入收货电话" />
          <van-field v-model="model.datas.express_address" label="收货地址" placeholder="请输入收货地址" />
        </van-cell-group>

        <van-button block type="default" @click="save()">保存配送信息</van-button>
      </div>
    </div>

    <!-- 其他 -->
    <div class="submit-block" />

    <div v-if="model.wor_node_id==='f4168a991c3011eca58e00163e10fd64'" style="position:fixed;bottom:0;width:100%">
      <van-button block type="primary" @click="confirm()">确认订单</van-button>
    </div>

    <div v-else-if="receipts.length>0" style="position:fixed;bottom:0;width:100%">
      <van-button block type="primary" @click="() => { this.displayReceipts = true }">您有{{receipts.length}}笔款项待支付</van-button>
    </div>

    <div v-if="model.status===100" style="position:fixed;bottom:0;width:100%">
      <van-button block type="primary" @click="() => { this.displayComments = true }">评价订单</van-button>
    </div>

    <!-- 订单评价 -->
    <van-popup v-model="displayComments">
      <div class="padding-10">
        <div v-for="(comment, index) in model.comments" :key="index">
          <h5>{{comment.name}}</h5>
          <van-rate v-model="comment.value" />
        </div>
      </div>
      <van-field
        v-model="model.comment"
        rows="2"
        autosize
        type="textarea"
        placeholder="点击输入投诉和建议"
      />
      <van-button block type="warning" @click="comment()">确认评价</van-button>
    </van-popup>

    <van-popup v-model="displayReceipts">
      <div class="padding-10" v-for="receipt in receipts" :key="receipt.id">
        <van-button block type="primary" @click="settle(receipt.id)">支付收款单：{{receipt.datas.price}}</van-button>
      </div>
    </van-popup>

    <van-popup v-model="displaySettles">
      <div class="padding-10">
        <van-button block type="primary" @click="pay(0)">现结</van-button>
      </div>
      <div class="padding-10" v-if="cusUser.cash>0">
        <van-button block type="warning" @click="pay(10)">个人余额支付（{{cusUser.cash}}元）</van-button>
      </div>
      <div class="padding-10" v-if="cusCompany!==undefined&&cusCompany.cash>0">
        <van-button block type="warning" @click="pay(11)">企业余额支付（{{cusCompany.cash}}元）</van-button>
      </div>
      <div class="padding-10" v-if="cusCompany!==undefined&&cusCompany.credit>0">
        <van-button block type="warning" @click="pay(20)">企业信用支付（{{cusCompany.credit}}元）</van-button>
      </div>
    </van-popup>
  </div>
</template>

<script>
import Api from '@/utils/api'
import wx from 'weixin-js-sdk'
export default {
  created () {
    Api.post('wei.user/jsapi', {url: window.location.href}, res => {
      let data = res.data
      wx.config({
        debug: false,
        appId: data.appid,
        timestamp: data.timestamp,
        nonceStr: data.noncestr,
        signature: data.signature,
        jsApiList: ['chooseWXPay']
      })
    })
    Api.post('wei.user/model', null, res => {
      this.weiUser = res.data
      if (res.data.cusUser !== undefined) this.cusUser = res.data.cusUser
      if (res.data.cusCompany !== undefined) this.cusCompany = res.data.cusCompany
    })
    this.reload()
  },
  data () {
    return {
      cusUser: undefined,
      cusCompany: undefined,
      weiUser: {},

      model: {},
      salProducts: [],
      receipts: [],

      receipt_id: '',

      displayComments: false,
      displayReceipts: false,
      displaySettles: false
    }
  },
  methods: {
    comment () {
      this.$dialog.confirm({title: '提示', message: '确认评价吗？'})
        .then(() => {
          Api.post('wor.request/comment', {id: this.$route.query.id, comments: JSON.stringify(this.model.comments), comment: this.model.comment}, res => { this.reload() })
        })
    },
    confirm () {
      this.$dialog.confirm({title: '提示', message: '确认订单吗？'})
        .then(() => {
          Api.post('wor.request/approve', {id: this.$route.query.id, ent_employee_id: '31f3a24b28c711eca58e00163e10fd64'}, res => { this.reload() })
        })
    },
    pay (settleType) {
      this.displaySettles = false
      if (settleType === 0) {
        var that = this
        wx.ready(function () {
          Api.post('pay.weixin/index', {wor_request_id: that.receipt_id}, res => {
            var payWeixin = res.data
            wx.chooseWXPay({
              timestamp: payWeixin.timestamp.toString(),
              nonceStr: payWeixin.noncestr,
              package: payWeixin.package,
              signType: 'MD5',
              paySign: payWeixin.sign,
              success: function (res) {
                // 核对订单支付状态
                Api.post('pay.weixin/model', {id: payWeixin.id}, res => {
                  if (res.is_check === 1) {
                    that.$toast.success('支付成功')
                  } else {
                    that.$toast.fail('支付异常')
                  }
                  that.reload()
                })
              },
              cancel: function (res) {
                console.log(res)
                that.$toast.fail('取消支付')
              },
              fail: function (res) {
                console.log(res)
                that.$toast.fail('支付失败')
              }
            })
          })
        })
      } else {
        Api.post('wor.request/settle', {id: this.receipt_id, settle_type: settleType}, res => {
          this.$toast.success('支付成功')
          that.reload()
        })
      }
    },
    reload () {
      Api.post('wor.request/model', {id: this.$route.query.id}, res => {
        this.model = res.data
        let ids = []
        res.data.wor_datarows.forEach(worDatarow => {
          if (worDatarow.wor_table_id !== '65b410ced7c411ebb59b797c008dc329') return true
          ids.push(worDatarow.datas.sal_product_id)
        })
        // 获取商品数据集
        Api.post('sal.product/models', {page: 1, limit: -1, ids: "'" + ids.join("','") + "'"}, res => {
          this.model.wor_datarows.forEach(worDatarow => {
            if (worDatarow.wor_table_id !== '65b410ced7c411ebb59b797c008dc329') return true
            var salProducts = []
            res.data.forEach(salProduct => {
              if (salProduct.id === worDatarow.datas.sal_product_id) {
                salProducts.push({
                  thumb: salProduct.thumb,
                  name: salProduct.name,
                  quantity: worDatarow.datas.quantity,
                  price: worDatarow.datas.price
                })
              }
            })
            this.salProducts = salProducts
          })
        })
        // 获取应收单数据集
        Api.post('wor.request/models', {parent_id: res.data.id, is_check: 0, page: 1, limit: -1, datas: 1}, res => { this.receipts = res.data })
      })
    },
    save () {
      Api.post('wor.request/persist', {id: this.model.id, datas: JSON.stringify(this.model.datas), datarows: '[]'}, res => { this.$toast.success('操作成功') })
    },
    settle (id) {
      this.receipt_id = id
      this.displayReceipts = false
      this.displaySettles = true
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/sal/order/Model.vue